module.exports = __webpack_public_path__ + "static/media/columns.d24be19c.svg";